import React, { useState } from 'react';
import { connect } from 'dva';
import { RequestTracerWrapper } from './styles';
import { Spin, Button, Input, Form } from 'antd';
import { REQUEST_TRACER_TITLE } from '../../constants';
import { isUUID } from 'validator';
import RequestTracerTabs from './RequestTracerTabs';
import { useLocation } from 'react-router-dom';
import { ErrorBox, ErrorList, ErrorListItem } from './styles';

const RequestTracer = ({ dispatch, traceData, error, loading }) => {
  const location = useLocation();
  const [traceId, setTraceId] = useState('');
  const [adId, setAdId] = useState('');
  const [tab, setTab] = useState('1');
  const [rowKey, setRowKey] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);
  const [showDetailPanel, setShowDetailPanel] = useState(false);
  const [selectedTraceData, setSelectedTraceData] = useState(null);

  // Parse query params on mount
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlTraceId = params.get('traceId') || '';
    const urlAdId = params.get('adId') || '';
    const urlTab = params.get('tab') || '1';
    const urlRowKey = params.get('rowKey');
    if (urlTraceId && urlAdId) {
      setTraceId(urlTraceId);
      setAdId(urlAdId);
      setTab(urlTab);
      setRowKey(urlRowKey);
      setShowSpinner(true);
      dispatch({
        type: 'requestTracer/fetchTraces',
        payload: { traceId: urlTraceId, adId: urlAdId, env: '' },
      });
    } else {
      // Reset all state to initial values if no params
      setTraceId('');
      setAdId('');
      setTab('1');
      setRowKey(null);
      setShowSpinner(false);
      setShowDetailPanel(false);
      setSelectedTraceData(null);
      setFormErrors({});
    }
  }, [location.search, dispatch]);

  const validate = () => {
    const errs = {};
    if (!traceId) errs.traceId = 'Trace ID cannot be empty';
    if (!isUUID(adId)) errs.adId = 'Invalid UUID format';
    setFormErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setShowSpinner(true);
    dispatch({
      type: 'requestTracer/fetchTraces',
      payload: { traceId, adId, env: '' },
    });
  };

  React.useEffect(() => {
    if (traceData && !loading && !error && traceId && adId) {
      setSelectedTraceData(traceData);
      setShowDetailPanel(true);
      setShowSpinner(false);
    } else {
      setShowDetailPanel(false);
    }
  }, [traceData, loading, error, traceId, adId]);

  // Collect all errors for display
  const errorMessages = [];
  if (formErrors.traceId) errorMessages.push(formErrors.traceId);
  if (formErrors.adId) errorMessages.push(formErrors.adId);
  if (error) {
    if (error.errorName) errorMessages.push(`${error.errorName}`);
    if (error.name) errorMessages.push(`${error.name}`);
    if (Array.isArray(error)) error.forEach((err) => errorMessages.push(err));
  }

  if (showDetailPanel && selectedTraceData && traceId && adId) {
    return (
      <RequestTracerWrapper>
        <RequestTracerTabs
          traceId={selectedTraceData.traceId || traceId || ''}
          adId={selectedTraceData.adId || adId || ''}
          tab={tab}
          rowKey={rowKey}
          invariantData={selectedTraceData.invariantQualification || []}
          slotData={selectedTraceData.slotQualification || []}
          invariantWidths={{}}
          slotWidths={{}}
        />
      </RequestTracerWrapper>
    );
  }

  return (
    <RequestTracerWrapper>
      <h2>{REQUEST_TRACER_TITLE} - Find Trace</h2>
      <br />
      {/* Error box above the form fields */}
      {errorMessages.length > 0 && (
        <ErrorBox data-testid="request-tracer-error-box">
          <ErrorList>
            {errorMessages.map((msg, idx) => (
              <ErrorListItem key={idx}>{msg}</ErrorListItem>
            ))}
          </ErrorList>
        </ErrorBox>
      )}
      <Form layout="vertical" onSubmitCapture={handleSubmit}>
        <Form.Item
          label={
            <span>
              Zipkin Trace ID<span style={{ color: 'red' }}> *</span>
            </span>
          }
          validateStatus={formErrors.traceId ? 'error' : ''}
          help={formErrors.traceId}
        >
          <Input value={traceId} onChange={(e) => setTraceId(e.target.value)} placeholder="Enter Zipkin Trace Id" />
        </Form.Item>
        <Form.Item
          label={
            <span>
              Ad ID<span style={{ color: 'red' }}> *</span>
            </span>
          }
          validateStatus={formErrors.adId ? 'error' : ''}
          help={formErrors.adId}
        >
          <Input value={adId} onChange={(e) => setAdId(e.target.value)} placeholder="Enter AD Id" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Search
        </Button>
      </Form>
      <div style={{ marginTop: 24 }}>{showSpinner && <Spin spinning={loading} />}</div>
    </RequestTracerWrapper>
  );
};

function mapStateToProps({ app, loading, requestTracer }) {
  return {
    traceData: requestTracer.traceData,
    error: requestTracer.error,
    loading: loading.effects['requestTracer/fetchTraces'],
    permissions: app.currentUser.permissions,
  };
}

export default connect(mapStateToProps)(RequestTracer);
